import { FilterKeys } from '@schooly/api';
import { PROPERTIES_TEXT_IDS } from '@schooly/constants';
import { forwardRef } from 'react';

import type {
  FilterDropdownSingleSelect as FilterDropdownSingleSelectRef,
  FilterDropdownSingleSelectProps,
} from '../FiltersDropdown/FilterDropdownSingleSelect';
import { FilterDropdownSingleSelect as FilterDropdownSingleSelectComponent } from '../FiltersDropdown/FilterDropdownSingleSelect';

declare module 'react' {
  function forwardRef<T, P = {}>(
    render: (props: P, ref: React.Ref<T>) => React.ReactElement | null,
  ): (props: P & React.RefAttributes<T>) => React.ReactElement | null;
}

type ArrangeByDropdownProps<T extends FilterKeys> = Omit<
  FilterDropdownSingleSelectProps<T>,
  'getOptionLabelId'
> & {
  getOptionLabelId?: (o: T) => string;
};

export type ArrangeByDropdown = FilterDropdownSingleSelectRef;

const ArrangeByDropdownComponent = <T extends FilterKeys>(
  { getOptionLabelId, ...rest }: ArrangeByDropdownProps<T>,
  ref: React.ForwardedRef<ArrangeByDropdown>,
) => {
  return (
    <FilterDropdownSingleSelectComponent
      {...rest}
      getOptionLabelId={(value: T) =>
        getOptionLabelId ? getOptionLabelId(value) : PROPERTIES_TEXT_IDS[value]
      }
      ref={ref as React.ForwardedRef<FilterDropdownSingleSelectRef>}
    />
  );
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArrangeByDropdown = forwardRef(ArrangeByDropdownComponent);
